import { IUserSessionState } from './types';

export const SLICE_NAMESPACE = 'userSession';

export const initialState: IUserSessionState = {
  role: null,
  subject: null,
  roleError: false,
};
